import React from 'react';
import { connect } from 'react-redux';
import { Button, Header, Modal } from 'semantic-ui-react';
import { showBankingCommentsModal } from '../../redux/actions/modals';
import CommentsList from '../shared/CommentsList';

class BankingCommentsModal extends React.Component {
  
  state = {

  }

  handleClose = (refresh) => {
    this.props.showBankingCommentsModal(false);
  }

  render() {
    return (
        <Modal
          open={this.props.modal.open}
          onClose={this.handleClose}
          size='small'
          closeIcon
        >
          <Modal.Header>
            <Header size="tiny" content="Collection Comments" subheader={this.props.modal.Header} />
          </Modal.Header>
          <Modal.Content scrolling>
            <CommentsList comments={this.props.modal.comments} />
          </Modal.Content>
          <Modal.Actions>
            <Button negative onClick={this.handleClose}>Close</Button>
          </Modal.Actions>
        </Modal>
    )
  }
}

const mapStateToProps = state => {
	return {
    modal: state.bankingCommentsModal,
  };
};

export default connect(mapStateToProps, { showBankingCommentsModal })(BankingCommentsModal);

